import { canViewWorkMessageDetails, workMessage, workDiagnosticData, workNotice } from './work-message-policy.mjs'

export default {
  computed: {
    canViewWorkMessageDetails() {
      return canViewWorkMessageDetails(this.$store?.getters?.permissionLevel)
    },
  },
  methods: {
    workNotice(value, record) {
      return workNotice(value, record, this.$store?.getters?.permissionLevel)
    },
    workDiagnosticJson(value) {
      return JSON.stringify(workDiagnosticData(value, this.$store?.getters?.permissionLevel), null, 2)
    },
    workMessage(value) {
      return workMessage(value, this.$store?.getters?.permissionLevel)
    },
  },
}
